import {
  getTaxPaymentInternalDeadline,
  getTaxPaymentIRSDeadline,
  Quarter
} from "@wingspanhq/utils/dist/date/taxDeadlines";
import { TaxPaymentScheduleQuarter } from "@wingspanhq/wingspan-api-sdk";

type SelectorOptions = {
  quarter?: TaxPaymentScheduleQuarter;
  year?: number;
  currentDate?: Date;
};

/**
 * Returns whether a scheduled tax payment is still before Wingspan's internal
 * cancellation cutoff. The backend rejects cancel/edit requests once its own
 * processing deadline passes, so the UI must agree or it offers an action the
 * API will refuse.
 */
export const selectorIsScheduledTaxPaymentCancellable = ({
  quarter,
  year,
  currentDate = new Date(Date.now())
}: SelectorOptions): boolean => {
  if (
    !quarter ||
    !Object.values(Quarter).includes(quarter as unknown as Quarter)
  ) {
    return false;
  }

  if (!Number.isInteger(year) || (year as number) <= 0) {
    return false;
  }

  const internalDeadline = getTaxPaymentInternalDeadline(
    getTaxPaymentIRSDeadline(quarter as unknown as Quarter, year as number)
  );

  return currentDate.getTime() <= internalDeadline.getTime();
};
